import { Button, Modal, Spinner } from '@platform/components';
import { CSVLink } from 'react-csv';
import { UseQueryResult } from '@tanstack/react-query';
import { SearchExportResponse } from '@platform/client/schemas';
import { repFiltersToQueryParams, proFiltersToQueryParams } from './utils';
import { ProUserFilters } from './ProUserSearchForm';
import { RepUserFilters } from './RepUserSearchForm';

type DownloadModalProps = {
  onClose: () => void;
  fetchFn: (
    options: Record<string, string | boolean | null>,
  ) => UseQueryResult<SearchExportResponse>;
} & (
  | {
      userType: 'pro';
      filters: ProUserFilters;
    }
  | {
      userType: 'rep';
      filters: RepUserFilters;
    }
);
export const DownloadResultsModal = (props: DownloadModalProps) => {
  const searchParams =
    props.userType === 'pro' ?
      proFiltersToQueryParams(props.filters)
    : repFiltersToQueryParams(props.filters);
  const { data, isError, isLoading, isSuccess } = props.fetchFn({
    ...searchParams,
  });
  return (
    <Modal
      variant='dialog'
      headerDivision='divider'
      title='Download Results'
      isOpen={true}
      onClose={props.onClose}
      ignoreExtraPadding={true}
    >
      <>
        {isLoading && <Spinner />}
        {isError && <p>Error fetching download data.</p>}
        {isSuccess && (
          <div className='flex justify-center gap-2'>
            <Button
              variant='secondary-danger'
              size='sm'
              additionalClassnames='w-fit'
              onClick={props.onClose}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              size='sm'
              additionalClassnames='w-fit'
              isDisabled={!isSuccess || !data || data.users.length === 0}
            >
              {isSuccess && data && (
                <CSVLink
                  filename={`export_${new Date().toISOString().replace(' ', '_')}.csv`}
                  data={data.users}
                >
                  Download csv
                </CSVLink>
              )}
            </Button>
          </div>
        )}
      </>
    </Modal>
  );
};
